import {useState} from "react";
import moment from "moment-timezone";
import config from "../config";
import {useSelector} from "react-redux";

export default function useCalendar() {
  const user = useSelector((state) => state.user);

  const [calendarData, setCalendarData] = useState({
    days: [],
    dates: [],
    months: [],
    weekStart: moment()
      .tz(user.timezone || config.defaultTimezone)
      .clone()
      .startOf("isoWeek"),
    weekEnd: moment()
      .tz(user.timezone || config.defaultTimezone)
      .clone()
      .endOf("isoWeek"),
    weekStart_month: "",
    weekEnd_month: "",
    monthEndDate: moment()
      .tz(user.timezone || config.defaultTimezone)
      .clone()
      .endOf("month")
      .format("DD"),
    monthEnd: moment()
      .tz(user.timezone || config.defaultTimezone)
      .clone()
      .endOf("month"),
    monthStart: moment()
      .tz(user.timezone || config.defaultTimezone)
      .clone()
      .startOf("month"),
    today_date: moment(new Date())
      .tz(user.timezone || config.defaultTimezone)
      .add(0, "days")
      .format("DD"),
    yesterday: moment(new Date())
      .tz(user.timezone || config.defaultTimezone)
      .add(-1, "days")
      .format("DD"),
    today_month: moment(new Date())
      .tz(user.timezone || config.defaultTimezone)
      .add(0, "days")
      .format("MMM"),
    yesterday_month: moment(new Date())
      .tz(user.timezone || config.defaultTimezone)
      .add(-1, "days")
      .format("MMM"),
    year: new Date().getFullYear(),
  });

  const weekFrom = moment(calendarData.weekStart)
    .tz(user.timezone || config.defaultTimezone)
    .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  const weekTo = moment(calendarData.weekEnd)
    .tz(user.timezone || config.defaultTimezone)
    .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  const monthFrom = moment(calendarData.monthStart)
    .tz(user.timezone || config.defaultTimezone)
    .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  const monthTo = moment(calendarData.monthEnd)
    .tz(user.timezone || config.defaultTimezone)
    .format("YYYY-MM-DDTHH:mm:ss.SSSZ");

  const getCalendarWeek = () => {
    let weekEnd_month = moment(calendarData.weekEnd._d)
      .tz(user.timezone || config.defaultTimezone)
      .format("MMM");
    let weekStart_month = moment(calendarData.weekStart._d)
      .tz(user.timezone || config.defaultTimezone)
      .format("MMM");

    let dates = [];
    let days = [];
    let months = [];

    for (let i = 0; i <= 6; i++) {
      dates.push(
        moment(calendarData.weekStart)
          .tz(user.timezone || config.defaultTimezone)
          .add(i, "days")
          .format("DD")
      );
      days.push(
        moment(calendarData.weekStart)
          .tz(user.timezone || config.defaultTimezone)
          .add(i, "days")
          .format("ddd")
      );
      months.push(
        moment(calendarData.weekStart)
          .tz(user.timezone || config.defaultTimezone)
          .add(i, "days")
          .format("MM")
      );
    }

    setCalendarData({
      ...calendarData,
      days: days,
      dates: dates,
      months: months,
      weekStart_month: weekStart_month,
      weekEnd_month: weekEnd_month,
    });
  };

  return {
    calendarData,
    setCalendarData,
    weekFrom,
    weekTo,
    monthFrom,
    monthTo,
    getCalendarWeek,
  };
}